import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CustomRoleFest {
    id: string;
    name: string;
    status: string;
    startDate: string;
    endDate: string;
    logo?: string | null;
}

interface CustomRoleState {
    selectedFest: CustomRoleFest | null;
}

const initialState: CustomRoleState = {
    selectedFest: null,
};

const customRoleSlice = createSlice({
    name: 'CustomRole',
    initialState,
    reducers: {
        setCustomRoleFest(state, action: PayloadAction<CustomRoleFest>) {
            state.selectedFest = action.payload;
        },
        clearCustomRoleFest(state) {
            state.selectedFest = null;
        },
    },
});

export const { setCustomRoleFest, clearCustomRoleFest } = customRoleSlice.actions;
export default customRoleSlice.reducer;
